export default __webpack_public_path__ + "static/media/Attribute_Wits.f3f08cce.png";